<template>
    <div class="story-maker-sticker story-maker-sticker-slider" :class="{edit: isEditing}">
        <img class="img-change-color" :src="require('../../../../../assets/img/instagram/ehf.png')">
        <p class="text-finish" @click="finish">Terminé</p>
        <div 
            class="sticker sticker-slider"
            :style="{ 
                top: `${$attrs.position.y}%`, 
                left: `${$attrs.position.x}%`,
                transform: isCover || isPreventCover ? `translate(-50%, -50%) scale(${$attrs.transform.scale}) rotate(${$attrs.transform.rotate}deg)` : ''
            }"
        >
            <div class="slider-header" v-if="isEditing || models.question">
                <textarea cols="20" rows="2" wrap="hard" maxlength="100" placeholder="Posez une question..." v-model="models.question" :readonly="!isEditing"></textarea>
            </div>
            <div class="slider">
                <span class="emoji">{{models.emoji}}</span>
                <div class="bar"></div>
            </div>
          
        </div>

        <div class="list-emoji">
            <carousel :perPage="1" :adjustableHeight="true" :centerMode="true" @pageChange="()=>{}" >
                <Slide v-for="(emojis,index) in [['😍','😂','😀','🔥','😡','😱','😢','🙌'],['❤️','🎉','👍','💩','💯','🙏','😮','add']]" :key="index">
                   
                    <template v-for="emo in emojis">
                        <div v-if="emo == 'add'" class="add"><i class="fa-regular fa-plus"></i></div>
                        <div v-else class="emoji" @click="models.emoji = emo">{{ emo }}</div>
                    </template>
                  
                </Slide>
            </carousel>
        </div>
     
    </div>
</template>

<script>
    import { Carousel, Slide } from 'vue-carousel';
    export default {
        components: {
            Carousel,
            Slide
        },

        props: {
            id: Number | String,
            isEditing: Boolean,
            emoji: String,
            question: String,
            isPreventCover: Boolean,
            isCover: Boolean,
            setCover: Function,
            setCbClick: Function,
        },

        mounted () {
            if (this.setCbClick) this.setCbClick(this.clickSticker);
        },

        data() {
            return {
                models: {
                    question : '',
                    emoji : '😍'
                }
            }
        },

        methods: {
            clickSticker() {
                if (this.isEditing) return 
                this.setCover(true)
                this.$nextTick(()=> {
                    this.$emit('updateSticker',this.id , {
                        isEditing: true
                    })   
                })
            },

            finish() {
                this.$emit('updateSticker',this.id , {
                    isEditing: false,
                    data : {
                        question : this.models.question,
                        emoji : this.models.emoji
                    },
                })

                if (this.timeoutFinish) clearTimeout(this.timeoutFinish)
                this.timeoutFinish = setTimeout(() => {
                    this.setCover(false)
                }, 200);
            },
        },

        watch: {
            question: {
                handler(newValue) {
                    this.models.question = newValue
                },
                immediate: true
            },
            emoji: {
                handler(newValue) {
                    this.models.emoji = newValue
                },
                immediate: true
            }
        }
    }
</script>

<style lang="scss" scoped>

</style>